import applogger from '@applogger'
let pageMixin
let asyncLoader

// eslint-disable-next-line no-undef
if (APPSETTINGS.DataStore.store === 'ichabodcms') {
  asyncLoader = function({ store, route }) {}

  pageMixin = {
    computed: {
      content() {
        return this.$store.getters['node/content_body'](this.itemid)
      },
      unpublished() {
        return (!this.$store.getters['node/published'](this.itemid))
      },
      attachedView() {
        return this.$store.getters['node/getAttachedView'](this.itemid)
      }
    },
    methods: {
    }
  }
}
else {
  asyncLoader = function({ store, route }) {
    applogger.log('node-page-website-list asyncData starting')
    return Promise.all([
      store.dispatch('node/load', {nid: 94, cacheOptions: {scope: 'global'}}),
      store.dispatch('node/attachedView', {nid: 94, cacheOptions: {scope: 'global'}})
    ])
      .then(() => {
        applogger.log('node-page-website-list asyncData Complete')
      })
  }
  pageMixin = {
    computed: {
      content() {
        return this.$store.getters['node/content_body'](this.itemid)
      },
      unpublished() {
        return (!this.$store.getters['node/published'](this.itemid))
      },
      attachedView() {
        return this.$store.getters['node/getAttachedView'](this.itemid)
      }
    },
    methods: {
      fetchAttachedView: function(view, filters = {}) {
        this.$aspediaLoader.getList(view[0], view[1], {}, filters)
          .then(response => { this.attachedView = response })
          .catch(e => applogger.error(`Error: ${e.message}`))
      },
      filterView: function() {
        let filterValues = {}
        let i
        for (i in Object.keys(this.$refs.filterForm.elements)) {
          if (this.$refs.filterForm.elements[i].type !== 'submit' && this.$refs.filterForm.elements[i].value) {
            filterValues[this.$refs.filterForm.elements[i].name] = this.$refs.filterForm.elements[i].value
          }
        }

        this.fetchAttachedView(this.node.field_v_content_view.vname.split('|'), filterValues)
      }
    }
  }
  pageMixin = {

  }
}

export default pageMixin
export {
  pageMixin,
  asyncLoader
}
